module.exports = __webpack_public_path__ + "static/media/nestje1.25032dc7.webp";